import {createSelector} from 'reselect';

import {UserPageState} from './listsSlice';

const selectListsState = (state: UserPageState) => state.userPage.tabs.content.lists;

export const makeSelectListsByUserId = (userId: number) =>
    createSelector(
        [selectListsState],
        listsState => {
            const userLists = listsState.countsByUserId[userId];
            return userLists || {
                total: 0,
                status: 'idle' as const,
                error: undefined,
                receivedAt: undefined,
            };
        },
    );

export const selectListsReceivedAt = (state: UserPageState, userId: number) => {
    const userLists = state.userPage.tabs.content.lists.countsByUserId[userId];
    return userLists?.receivedAt;
};
